<template>
  <div class="dtp-main">
		<div>{{ selectedDateTime }}</div>
		<DateTimePicker :value.sync="selectedDateTime"/>
	</div>
</template>

<script>
import DateTimePicker from '@/components/DateTimePicker.vue';

export default {
  components: {
		DateTimePicker
	},
	props: {
		selectedDateTime: { type: Date, default: null }
	},
  methods: {}
};
</script>

<style lang="scss" scoped>
.dtp-main {
	// height: 100%;
	flex-direction: column;
}
</style>